/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';

const NavigationMenu = React.memo(({ menuItems }) => {
  const handleClick = React.useCallback((e, item) => {
    e.preventDefault();
  }, []);

  const handleClickSubMenu = React.useCallback((e, subItem) => {
    e.preventDefault();
    const elementId = subItem.url.split('#')[1]; // URL'den ID'yi al
    const element = document.getElementById(elementId);
    
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, []);

  return (
    <ul className="navbar-nav gap-xl-5 gap-4 mx-auto py-xl-0 py-4 pb-2">
      {menuItems.map((item) => (
        <li
          key={item.id}
          className={`nav-item ${item.subMenu ? "dropdown" : ""}`}
        >
          {item.subMenu ? (
            <>
              <a
                href="#"
                className="nav-link text-gray-darker p-0 d-flex align-items-center"
                onClick={(e) => handleClick(e, item)}
              >
                {item.title}{" "}
                <i className="fas fa-caret-down small ms-2"></i>
              </a>

              <ul className="dropdown-menu border-0 shadow-sm rounded-3">
                {item.subMenu.map((subItem) => (
                  <li key={subItem.id}>
                    <a 
                      href={subItem.url} 
                      className="dropdown-item" 
                      rel="noreferrer" 
                      onClick={(e) => handleClickSubMenu(e, subItem)}
                    >
                      {subItem.title}
                    </a>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <a
              className="nav-link text-gray-darker p-0"
              href={item.url}
              target={item?.newWindow ? "_blank" : "_self"} rel="noreferrer"
            >
              {item.title}
            </a>
          )}
        </li>
      ))}
    </ul>
  );
});

NavigationMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      title: PropTypes.string.isRequired,
      url: PropTypes.string,
      subMenu: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
          title: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
};

export default NavigationMenu; 